"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSamplesToText = exports.hashLabelMap = exports.isValidLabels = exports.isValidCollectorName = void 0;
function isValidCollectorName(name) {
    return !!name && /[a-zA-Z_:][a-zA-Z0-9_:]*/.test(name);
}
exports.isValidCollectorName = isValidCollectorName;
function isValidLabels(labels) {
    return labels.every(function (label) { return /[a-zA-Z_][a-zA-Z0-9_]*/.test(label); });
}
exports.isValidLabels = isValidLabels;
function hashLabelMap(labelMap) {
    var labels = Object.keys(labelMap);
    var result = '';
    if (labels.length > 0) {
        labels = labels.sort();
        result = labels
            .map(function (label) {
            return "".concat(label, ":").concat(labelMap[label]);
        })
            .join('|');
    }
    return result;
}
exports.hashLabelMap = hashLabelMap;
function convertSamplesToText(samples) {
    var textSamples = [];
    for (var _i = 0, samples_1 = samples; _i < samples_1.length; _i++) {
        var sample = samples_1[_i];
        var labelInText = Object.entries(sample.labels).map(function (_a) {
            var label = _a[0], value = _a[1];
            return "".concat(label, "=\"").concat(value, "\"");
        });
        var sampleInText = labelInText.length > 0
            ? "".concat(sample.name, "{").concat(labelInText, "} ").concat(sample.value, "\n")
            : "".concat(sample.name, " ").concat(sample.value, "\n");
        textSamples.push(sampleInText);
    }
    return textSamples;
}
exports.convertSamplesToText = convertSamplesToText;
//# sourceMappingURL=utils.js.map